<template>
  <div>
    <el-input v-model="formData.showName"
              @click.native="openDialog"
              placeholder="请选择!"
              :size="size">
      <el-button slot="append" icon="el-icon-close" @click.stop="clearData"></el-button>
    </el-input>

    <esp-el-dialog title="部门选择"
                   width="400px"
                   height="90%"
                   ref="curDialog"
                   class="esp_dept_dialog"
                   :use-scrollbar="false"
                   @doAction="doAction">
      <div class="esp_dept_content">
        <div class="esp_dept_head">
          <el-input v-model="initData.filterText"
                    prefix-icon="el-icon-search"
                    placeholder="输入关键字查询..."
                    clearable>
          </el-input>
        </div>
        <div class="esp_dept_body">
          <el-scrollbar class="esp_scrollbar">
            <el-tree :data="initData.treeData"
                     :props="defaultProps"
                     :filter-node-method="filterNode"
                     :highlight-current="true"
                     default-expand-all
                     node-key="id"
                     ref="tree"
                     @node-click="rowClick">
                <span class="esp-custom-tree-node" slot-scope="{ node, data }">
                  <span>
                    <i class="el-icon-s-home"></i> {{ node.label }}
                  </span>
                  <span>
                    <el-button type="text" size="mini" @click="dbClick(data)">选择</el-button>
                  </span>
               </span>
            </el-tree>
          </el-scrollbar>
        </div>
      </div>
    </esp-el-dialog>
  </div>
</template>

<script>
import * as deptdoc from "@/api/base/deptdoc";

export default {
  name: "EspDeptdoc",
  data() {
    return {
      initData: {
        treeData: [],                   // 树形数据
        filterText: '',                 // 过滤的文字
        pk_corp: this.pk_corp           // 默认选中的公司
      },

      formData: {
        showName: '',                   // 显示在输入框中的名称
        selectedData: {}                // 选中的数据
      },

      defaultProps: {
        children: 'children',
        label: 'label'
      }
    }
  },
  props: {
    value: {
      type: String
    },
    pk_corp: {
      type: String
    },
    size: {
      type: String,
      default: 'small'
    }
  },
  methods: {
    /**
     * 开启选择
     */
    openDialog: function () {
      this.doLoadData();
      this.$refs.curDialog.opened();
    },

    /**
     * 清除已选数据
     */
    clearData: function () {
      this.$emit('input', '');
      this.$emit('change', '');
    },

    /**
     * 点击确定按钮
     */
    doAction: function (callback) {
      this.$emit('input', this.formData.selectedData.pk);
      this.$emit('change', this.formData.selectedData.pk);
      this.$emit('afterSelect', this.formData.selectedData);
      callback(true);
    },

    /**
     * 树节点过滤事件
     */
    filterNode: function (value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },

    /**
     * 单击选中
     */
    rowClick: function (row) {
      this.formData.selectedData = row.nodedata;
    },

    /**
     * 双击行选中
     */
    dbClick: function (row) {
      this.formData.selectedData = row.nodedata;
      this.$refs.curDialog.doAction();
    },

    /**
     * 加载数据
     */
    doLoadData: function () {
      deptdoc.listTree({searchParam: {pk_corp: this.initData.pk_corp}}).then(res => {
        this.initData.treeData = res.data;
      }).catch(error => {
      });
    }
  },
  watch: {
    "initData.filterText": function (val) {
      this.$refs.tree.filter(val);
    },
    value: {
      handler(newVal, oldVal) {
        this.formData = {showName: "", selectedData: {}};
        if (newVal) {
          deptdoc.get(newVal).then(res => {
            if (res.data) {
              this.formData.selectedData = res.data;
              this.formData.showName = res.data.name;
            }
          });
        }
      },
      deep: true,
      immediate: true
    },
    // 公司变化，就清空，查询是打开的时候查询的
    pk_corp: {
      handler(newVal, oldVal) {
        if (!newVal) {
          this.initData.pk_corp = 'NO-Data';
          this.initData.treeData = [];
        } else {
          this.initData.pk_corp = newVal;
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
<style lang="less">
.esp_dept_content {
  height: 100%;
  display: flex;
  flex-direction: column;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;

  .esp_dept_head {
    .el-input {
      width: calc(100% - 5px) !important;
    }
  }

  .esp_dept_body {
    flex: 1;
    padding: 5px 0px;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .esp-custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      padding-right: 8px;
    }
  }
}

.esp_dept_dialog {
  &.esp_dialog .el-dialog__body .el-scrollbar__view {
    padding-right: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/base/deptdoc/EspDeptdoc.vue